import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Alert, CircularProgress } from '@mui/material';
import MDBox from 'components/MDBox';
import { getBaskets } from 'services/api/basket';

import BasketGrid from '../basketGrid';

export default function BasketsPage() {
    // Fetch saved baskets
    const {
        data: basketsData,
        isLoading,
        error,
    } = useQuery({
        queryKey: ['baskets'],
        queryFn: () => getBaskets(),
        select: (data) => data?.data?.result || [],
    });

    if (isLoading) {
        return (
            <MDBox py={3}>
                <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                    <CircularProgress />
                </MDBox>
            </MDBox>
        );
    }

    if (error) {
        return (
            <MDBox py={3}>
                <Alert severity="error">Sepetler yüklenirken hata oluştu: {error.message}</Alert>
            </MDBox>
        );
    }

    return (
        <MDBox p={3}>
            {basketsData?.length === 0 ? (
                <Alert severity="info">Henüz kayıtlı sepetiniz bulunmuyor.</Alert>
            ) : (
                <MDBox>
                    {basketsData?.map((basket) => (
                        <MDBox key={basket._id} mb={3}>
                            <BasketGrid basketData={basket} basketSource="external" />
                        </MDBox>
                    ))}
                </MDBox>
            )}
        </MDBox>
    );
}
